import { put, select } from 'redux-saga/effects';
import { ScreenshareSourceDetails } from 'features/layout/types';
import { selectScreenshareStreams } from 'features/layout/features/order/orderSlice';
import { screenshareSelected } from 'features/screenshare/actions';
import {
  gridPanelOpened,
  gridPanelVoided,
  selectGridPanel,
  selectLockedScreenshare,
} from 'features/layout/features/content/contentSlice';
import { GridPanelName } from 'features/layout/features/content/types';
import { selectShowAllScreens } from 'features/screenshare/screenshareSlice';

export function* openLastActiveScreenshareSaga(feedId?: string) {
  const orderedScreenshares: ScreenshareSourceDetails[] = yield select(selectScreenshareStreams);
  const showAllScreens: boolean = yield select(selectShowAllScreens);
  const currentOpenedPanel: GridPanelName = yield select(selectGridPanel);

  const remainingScreenshares = orderedScreenshares.filter((item) => item.feedId !== feedId);

  if (remainingScreenshares.length > 0) {
    if (currentOpenedPanel !== 'screenshare') {
      yield put(gridPanelOpened('screenshare'));
    }

    // a single screen never belongs in the grid: select it so we land in the single view
    // (which also collapses show-all) instead of a one-tile grid with no selection
    const collapseToSingle = !showAllScreens || remainingScreenshares.length === 1;

    if (collapseToSingle) {
      const lockedScreenshare: ScreenshareSourceDetails | undefined =
        yield select(selectLockedScreenshare);

      // `remainingScreenshares` is pre-sorted by timestamp descending.
      const target = lockedScreenshare ?? remainingScreenshares[0];

      yield put(
        screenshareSelected({
          feedId: target?.feedId ?? '',
          userId: target.userId,
          update: true,
        })
      );
    }
  } else {
    yield put(gridPanelVoided('screenshare'));
  }
}
